module.exports = __webpack_public_path__ + "web/img/type-2.5e54ad29.png";